import { Action, AnyAction, combineReducers, Reducer, ReducersMapObject } from 'redux';

export interface ReducerManager<S = unknown, A extends Action = AnyAction> {
    reduce: Reducer<S, A>;
    add: (key: string, reducer: Reducer) => void;
}

export const createReducerManager = <S extends Record<string, unknown> = {}, A extends Action = AnyAction>(
    initialReducers: ReducersMapObject<S, A>
): ReducerManager<S, A> => {
    const reducers = { ...initialReducers };

    let combinedReducer = combineReducers(reducers);

    const reduce: Reducer<S, A> = (state, action) => combinedReducer(state, action);

    return {
        reduce,

        add: (key: keyof S, reducer: Reducer) => {
            if (!key || reducers[key]) {
                return;
            }

            reducers[key] = reducer;
            combinedReducer = combineReducers(reducers);
        },
    };
};
